import classNames from "classnames";
import Card from "./card";
import styles from "./index.module.less";
export default function Advantage({ config, isMobile }) {
  return (
    <div className={styles.headerContent}>
      <h2 className={classNames([styles.title, styles.orange])}>为什么选择?</h2>
      <h2 className={styles.title}>花瓣素材大企业授权定制</h2>
      <div className={styles.subTitle}>更全面、更安全、更高性价比</div>
      {config?.advantage.map((item, index) => (
        <Card item={item} key={index} reverse={index % 2 !== 0}></Card>
      ))}
    </div>
  );
}
